import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const createEvent = createAsyncThunk("createEvent", async (data) => {
  const response = await API.post("event/create", data);
  return response.data;
});

export const getEvents = createAsyncThunk(
  "getEvents",
  async ({ page, limit, search, startOfMonth, endOfMonth }) => {
    const response = await API.get("event/list", {
      params: { page, limit, search, startOfMonth, endOfMonth },
    });
    return response.data;
  }
);

export const getEventDetail = createAsyncThunk(
  "getEventDetail",
  async ({ id }) => {
    const response = await API.get("event/details", {
      params: { id },
    });
    return response.data;
  }
);
export const getEventReqSongs = createAsyncThunk(
  "getEventReqSongs",
  async ({ limit, page, clientId, eventId }) => {
    const response = await API.get("event/requested-song", {
      params: { limit, page, clientId, eventId },
    });
    return response.data;
  }
);

export const getSongReqSongs = createAsyncThunk(
  "getSongReqSongs",
  async ({ limit, page, search }) => {
    const response = await API.get("event/view-requestedSong", {
      params: { limit, page, search },
    });
    return response.data;
  }
);

export const getEventSongs = createAsyncThunk(
  "getEventSongs",
  async ({ limit, page, eventId }) => {
    const response = await API.get("event/song", {
      params: { limit, page, eventId },
    });
    return response.data;
  }
);

export const getClientsEvents = createAsyncThunk(
  "getClientsEvents",
  async ({ page, limit, search, clientId }) => {
    const response = await API.get("client/events", {
      params: { page, limit, search, clientId },
    });
    return response.data;
  }
);

export const editEvent = createAsyncThunk("editEvent", async (data) => {
  const response = await API.put("event/edit", data);
  return response.data;
});
export const resetClientPassword = createAsyncThunk(
  "resetClientPassword",
  async (data) => {
    const response = await API.put("auth/reset", data);
    return response.data;
  }
);

export const deleteEvent = createAsyncThunk("deleteEvent", async ({ id }) => {
  const response = await API.delete("event/delete", {
    params: { id },
  });
  return response.data;
});

export const unlockChoice = createAsyncThunk("unlockChoice", async (payload) => {
  const response = await API.put("event/unlockChoice", payload);
  return response.data;
});

// request users for new user
export const getNewUsers = createAsyncThunk(
  "getNewUsers",
  async ({ page, limit, search, startDate, endDate, from, to, is_contacted }) => {
    const response = await API.get("event/request-form", {
      params: { page, limit, search, startDate, endDate, from, to, is_contacted },
    });
    return response.data;
  }
);
export const downNewUserCSV = createAsyncThunk(
  "downNewUserCSV",
  async (payload) => {
    const response = await API.post("client/new-user", payload);
    return response.data;
  }
);
export const downClientsCSV = createAsyncThunk(
  "downClientsCSV",
  async (payload) => {
    const response = await API.post("client/new-user", payload);
    return response.data;
  }
);
export const getMusician = createAsyncThunk("getMusician", async () => {
  const response = await API.get("event/musician");
  return response.data;
});
export const updateSongRequest = createAsyncThunk(
  "updateSongRequest",
  async (data) => {
    const response = await API.post("event/approve-song", data);
    return response.data;
  }
);

// change request for user
export const getChangeRequestList = createAsyncThunk(
  "getChangeRequestList",
  async ({ page, limit, search }) => {
    const response = await API.get("requestchange/list", {
      params: { page, limit, search },
    });
    return response.data;
  }
);

// for Contacted
export const updateIsContacted = createAsyncThunk(
  "updateIsContacted",
  async ({ userId, is_contacted }, { rejectWithValue }) => {
    try {
      const response = await API.post("/event/update_contactstatus", {
        userId,
        is_contacted,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
